import { Fetch } from "../utils/fetch";
/**
 * Sample操作封装
 */
export class MarketReportApi {
  // 新上传缩略图地址
  addUploadPicUrl =
    process.env.BASE_API + "MarketReportType/InsertReportTypeAndPic";
  // 编辑上传缩略图地址
  updateUploadPicUrl =
    process.env.BASE_API + "MarketReportType/UpdateReportTypeNew";
  /**
   * 保存数据
   * @param {SampleForm} data 保存数据对象
   */
  getByPage(data) {
    return Fetch.fetch({
      url: "MarketReportType/GetByPage",
      method: "get",
      params: data,
    });
  }
  getReportTypeById(data) {
    return Fetch.fetch({
      url: "MarketReportType/GetReportTypeById",
      method: "get",
      params: data,
    });
  }
  insertReportType(data) {
    return Fetch.fetch({
      url: "MarketReportType/InsertReportType",
      method: "post",
      data: data,
    });
  }
  updateReportType(data) {
    return Fetch.fetch({
      url: "MarketReportType/UpdateReportTypeNew",
      method: "post",
      data: data,
    });
  }
  deleteReportType(data) {
    return Fetch.fetch({
      url: "MarketReportType/DeleteReportType",
      method: "delete",
      params: data,
    });
  }
  /**
   * 获取临时stsToken
   * @export
   * @param {any} data
   */
  getStsToken(data) {
    return Fetch.fetch({
      url: "Token/GetStsToken",
      method: "get",
      params: data,
    });
  }
  /**
   * 保存pdf文件路径到后台
   * @export
   * @param {any} data
   */
  savePdfPath(data) {
    return Fetch.fetch({
      url: "MarketReportFile/SavePafPath",
      method: "post",
      data: data,
    });
  }
  /**
   * 导出报告的用户下载记录
   * @export
   * @param {any} data
   */
  exportDownloadRecord(data) {
    return Fetch.fetch({
      url: "UserEnrollInfo/ExportReportUserDownLoadLog",
      method: "post",
      data: data,
      responseType: "arraybuffer",
    });
  }
}
